module.exports = '<svg width="51" height="32" viewBox="0 0 51 32"><path d="M44.8 1.6v7.616L27.04.352A3.285 3.285 0 0 0 25.6 0a3.192 3.192 0 0 0-3.2 3.2v6.016L4.64.352A3.295 3.295 0 0 0 3.2 0c-.576 0-1.184.16-1.696.48A3.196 3.196 0 0 0 0 3.2v25.6c0 1.12.576 2.144 1.504 2.72.96.576 2.144.64 3.136.128l17.76-8.899V28.8c0 1.12.576 2.144 1.507 2.72.957.576 2.144.64 3.133.128l17.76-8.899V30.4a1.6 1.6 0 0 0 1.6 1.6h3.2a1.6 1.6 0 0 0 1.6-1.6V1.6A1.6 1.6 0 0 0 49.6 0h-3.2a1.6 1.6 0 0 0-1.6 1.6z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/next-2.js
// module id = 1304
// module chunks = 14